/* 16145 协议*/

import queue from '../base/queue.js';

import jsapi_log from '../jsbridge/jsapi_log.js';
import env from '../common/env.js';
import Dom from '../base/mdom.js';
import { KvReportProtocolConfig, msgToKvString } from "./kvreport";
var win         = Dom.window;
var TypeEnum = {
    CGI     : 0,
    LOGIC   : 1,
    CSS     : 2,
    JS      : 3,
    IMAGE   : 4,
    JSAPI   : 5,
    COMMLIB : 6,
    BADJS   : 7,
    CACHEKEY: 8,
    FEATURE_DETECT: 9,
    EEVEE: 10
};

var TypeTextEnum = {
    CGI     : 'CGI',
    LOGIC   : 'LOGIC',
    CSS     : 'CSS',
    JS      : 'JS',
    IMAGE   : 'IMAGE',
    JSAPI   : 'JSAPI',
    COMMLIB : 'COMMLIB',
    BADJS   : 'BADJS',
    CACHEKEY: 'CACHEKEY',
    FEATURE_DETECT: 'FEATURE_DETECT',
    EEVEE   : "EEVEE"
};
var LOGIC_CONST = {
    TypeEnum:TypeEnum,
    TypeTextEnum:TypeTextEnum
};


var getType     = function(target){
    return Object.prototype.toString.call(target)
                 .replace(/\]/g,'')
                 .split(' ')[1];
}
var isNumber    = function(tar){
    return 'Number' == getType(tar);
}
var isJson      = function(tar){
    return 'Object' == getType(tar);
}
var isString    = function(tar){
    return 'String' == getType(tar);
}
/**
 * reportGameWeb 的data参数如下示例。
 * {
                type        : '2',
                isReportNow : '1',
                data        : {
                    '30'        : 5,
                    '31'      : 'openUrlWithExtraWebview',
                    '32'      : encodeURIComponent('test=1&b=s'),
                    '33'      : JSON.stringify({err_msg:'open:ok'}),
                    '34'    : 400
                }
            }
 *
 * @returns
 */
function generateReportFn(){
    var reportQueue = new queue();
    reportQueue.setSync();

    var isVerified = false;
    return function(collectedData,wxBridge){
        if( wxBridge ){
            reportQueue.run(function(){
                var context = this;
                if( true === isVerified ){
                    setTimeout(function(){
                        context.done();
                    },0);
                }else{
                    if(!wxBridge.verifyJsapi){
                        context.done();
                        return;
                    }
                    wxBridge.verifyJsapi(wxBridge.apis,
                    function(bret,res){
                        if(true === bret){
                            isVerified = true;
                            context.done();
                        }else{
                            jsapi_log.logError(
                                'EndLogic',
                                'get jsapi reportGameWeb failed'
                            );
                            context.done();
                        }
                    });
                }
            });
        }

        reportQueue.run(function(){
            var context = this;

            /**
             * 只在7.0.0之上，才可用。
             */
            var currentVersion = env.clientVersion(true);
            if( env.versionCompare(currentVersion,'7.0.0') < 0){
                context.done();
                return;
            }

            var treport = function(){
                if( !env.canIReport() ) {
                    context.done();
                    return
                }
                if( env.isMiniprogram() ) {
                    let config = KvReportProtocolConfig["quality"];
                    /**
                     * From zimyuan. https://minigamefe.pages.woa.com/classes/minigame_keyvaluereport.default.html
                     * reportKeyValue的是从协议的第24个字段开始按序拼接上报的。强行过滤一下index >= 24的
                    **/
                    let reportStr = msgToKvString(collectedData, config.columns.filter(v => v.index >= 24));
                    win.WeixinJSBridge.invoke('invokeMiniProgramAPI',{
                        name: 'reportKeyValue',
                        arg: {
                            key: config.logid,
                            value: reportStr,
                            immediately: true,
                            number: true,
                        },
                    });
                    context.done();
                }else {
                    win.WeixinJSBridge.invoke('reportGameWeb',{
                        type        : '2',
                        isReportNow : '1',
                        data        : collectedData
                    },function(res){
                        context.done();
    
                        var fail  = false;
                        if( env.isiOS ){
                            fail = (res.result != ''+0);
                        }
                        if( env.isAndroid ){
                            fail = (res.err_msg.indexOf(':ok') == -1)
                        }
                        if( fail ) {
                            jsapi_log.logError(
                                'EndLogic',
                                'jsapi reportGameWeb call fail',
                                res,collectedData
                            );
                        }
                    });
                }
            };
            if (!win.WeixinJSBridge) {
                window.document.addEventListener('WeixinJSBridgeReady',function() {
                    treport()
                });
            }
            else{
                treport();
            }
        });
    };
}
function generateReportPCFn(){
    var that = this;

    var dataQueue = function(){
        this.queue = [];
        this.lastReportTime = 0;
        this.timer = null;
    };
    dataQueue.prototype.push = function(itme){
        this.queue.push(itme);
        if( !this.timer ){
            this.timer = setTimeout(function(){
                this.lastReportTime = Date.now();
                this.trigger && this.trigger(this.queue);
                this.queue.length = 0;
                clearTimeout(this.timer);
                this.timer = null;
            }.bind(this),1000);
        }
        if( this.queue.length >= 5 ){
            this.lastReportTime = Date.now();
            this.trigger && this.trigger(this.queue);
            this.queue.length = 0;
        }

    };
    var DQ = new dataQueue();
    DQ.trigger = function(){
        if( Dom.report16145 ){
            Dom.report16145(this.queue);
        }
    };
    var enqueueReport = function(collectedData,report16145,DQ){
        var reportItem  = {
            Type    :collectedData['30'],
            Target  :collectedData['31'],
            Params  :collectedData['32'],
            Result  :collectedData['33'],
            CostTime:collectedData['34']
        };
        /**入队一下 */
        DQ.push(reportItem);
    };
    return function(collectedData){

        if( !Dom.report16145Loaded ){
            Dom.report16145Loaded = true;
            var report16145 = require('../report/16145_batch.js').default;
            /**这句话要在 enqueueReport前。因为enqueueReport需要要这个东西 */
            Dom.report16145 = report16145;
            enqueueReport(collectedData,report16145,DQ);
        }else{
            Dom.report16145 && enqueueReport(collectedData,Dom.report16145,DQ);
        }

    }
}
var Runner      = generateReportFn();
var PCRunner    = generateReportPCFn();

function insertEnvToResult(result) {
    result = result || {};
    result.webview = {};

    var KERNAL_TYPE = {
        'X5'            : 'X5',
        'XWEB'          : 'XWEB',
        'WKWEB'         : 'WKWEB',
        'UIWEB'         : 'UIWEB',
        'ANDROIDUNKNOW' : 'ANDROIDUNKNOW',
        'IOSUNKNOW'     : 'IOSUNKNOW'
    };

    if( env.isiOS ){
        if( env.isWKweb ){
            result.webview.kernal = KERNAL_TYPE.WKWEB;
        }else{
            result.webview.kernal = KERNAL_TYPE.UIWEB;
        }
    }else if( env.isAndroid ){
        if( env.isX5 ){
            result.webview.kernal = KERNAL_TYPE.X5;
        }else if( env.isXweb ){
            result.webview.kernal = KERNAL_TYPE.XWEB;
        }else{
            result.webview.kernal = KERNAL_TYPE.ANDROIDUNKNOW;
        }
    }
    return result;
}

/**
 *
 *
 * @param {string} type
 * @param {string} target
 * @param {json} params
 * @param {object} wxBridge
 * @returns
 */
function StartLogic(type,target,params,wxBridge){
    var startTime = (new Date()).getTime();
    if(undefined != type && !( type in LOGIC_CONST.TypeEnum ) ){
        throw 'Illegal StartLogic Params: type, see LOGIC_CONST.js';
    }

    if(undefined != target && !isString(target) ){
        throw 'Illegal StartLogic Params: target,need string';
    }

    if(undefined != params && !isJson(params)){
        throw 'Illegal StartLogic Params: params,need a json';
    }

    return {
        EndLogic:function(result){
            var endTime = (new Date()).getTime();

            /** 向result 注入一些默认的环境变量。 */
            result = insertEnvToResult(result);
            var costTime = endTime - startTime
            if( result && result.cost_time ) { // 支持业务自定义cost_time
                costTime = result.cost_time
            }

            var data = {
                Type        : LOGIC_CONST.TypeEnum[type],
                Target      : encodeURIComponent(target + '').substr(0,1024),
                Params      : encodeURIComponent(JSON.stringify(params)).substr(0,1024),
                Result      : encodeURIComponent(JSON.stringify(result)).substr(0,1024),
                CostTime    : costTime
            }

            /**
             * 这里会调用jsapi客户端会打日志，另外点击流也有日志【删除】
             */
            // jsapi_log.logInfo(
            //     'EndLogic',
            //     'this means i called reportGameWeb seriously',
            //     type,target,params,result
            // );

            if( type === LOGIC_CONST.TypeTextEnum.JSAPI){
                var filter = require('./quality_jsapi_filter.js').default;
                if( filter.isOK(target,result) ){
                    return;
                }
            }

            var url = '';
            try {
                url = window.location.href.replace(location.search,'')
                                          .replace(location.hash,'');
            }catch(err){

            }

            var TRunner = function(){};
            if( env.isWechat || env.isPcWechat){
                TRunner = Runner;
            }else{
                TRunner = PCRunner;
            }
            TRunner.call(this,{
                '30'        : data.Type,
                '31'        : data.Target,
                '32'        : data.Params,
                '33'        : data.Result,
                '34'        : data.CostTime,
                '35'        : encodeURIComponent(url)
            },undefined);
        }
    }
}

/**
 * 只用于 自定义逻辑的打log
 *
 * @param {*} target
 * @param {*} params
 * @param {*} wxBridge
 * @returns
 */
function StartRunner(target,params,wxBridge){
    return StartLogic(
        LOGIC_CONST.TypeTextEnum.LOGIC,
        target,params,wxBridge
    );
}

export default {
    StartRunner : StartRunner,
    StartLogic  : StartLogic,
    LOGIC_CONST : LOGIC_CONST
};
